import Vue from 'vue'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

import firebase from "firebase"
Vue.use(firebase)
firebase.initializeApp({
  apiKey: "AIzaSyCFIu9F2mzJ3mdm-MUXQOs_uX_d6gNVLJU",
  authDomain: "luna-observatory.firebaseapp.com",
  databaseURL: "https://luna-observatory.firebaseio.com",
  projectId: "luna-observatory",
  storageBucket: "luna-observatory.appspot.com",
  messagingSenderId: "101274652151"
});
import firebaseui from "firebaseui"
Vue.use(firebaseui)
// instantiate; use firebaseui.auth.AuthUI.getInstance()
new firebaseui.auth.AuthUI(firebase.auth())

import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'
sync(store, router)

import * as vue2vis from 'vue2vis'
Vue.component('timeline', vue2vis.Timeline)

import App from './App.vue'

new Vue({
  router, store,
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js